
import { PodDexController } from "@/app/ui/controllers/PodDexController";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {}
})
export default class Delivery extends Vue {

  mounted() {
    PodDexController.initDataTable();
  }

  unmounted() {
    PodDexController.onReset();
  }
  get tabs() {
    return [
      { name: "del/dex", title: this.$t("podDex.tabDelDex") as string },
      { name: "codrej", title: this.$t("podDex.tabCodrej") as string },
      { name: "pod", title: this.$t("podDex.tabPod") as string }
    ];
  }

  changeTabs(value: string) {
    this.$router.push({
      name: value
    });
    PodDexController.initDataTable();
    PodDexController.setType(value === "del/dex" ? "DEL-DEX" : value.toUpperCase());
    PodDexController.onReset();
  }

  isTabActive(name: string) {
    return name === this.$route.name;
  }
}
